'use strict'

my_stuff_menu_template = require '../my_stuff_menu.html.mustache'
my_stuff_layout_template = require '../../../components/mystuff.html.mustache'
user_nav_template = require '../vVERSION.html.mustache'

{ addReferrer } = require '../../../../../src/frontend/helper/general/m_userSessionAddReferrer'
{ fetchUser } = require '../../../../../src/frontend/helper/user/fetchUser'
CartWidget = require '../../../../cart_widget/frontend/cart_widget'
SignInFlyout = require '../../signin_flyout/frontend/signin_flyout'
LanguageSelector = require '../../language_menu/frontend/language_selector'
{ matchMQ, addMQListener } = require '../../../../../src/frontend/helper/mediaQueries/mediaQueries'
#myPlacesWidget = require '../../../../my_places/frontend/myplaces_widget'


buildResponsiveMenu = ->
  if Groupon.PageFlags?.isLegacyResponsive
    responsive_menu = require '../../responsive_menu/frontend/responsive_menu'
    new responsive_menu

###*
# @public
###
removeCachedUserData = ->
  fetchUser.removeUserData()

setCartWidget = ->
  new CartWidget '.cart-widget' if $('#ls-user-nav .cart-widget').length

appendLanguageMenu = (hasUser) ->
  $langMenu = $('#ls-lang-menu').removeClass('ls-hide')
  return unless $langMenu.length

  new LanguageSelector()
  return if not $('.big-searchbar').length # Not for black header

  $container = $('#ls-user-nav .user-menu')
  if hasUser
    $langMenu.insertAfter '#user-help'
  else
    $container.append $langMenu

updateSigninFlyoutPlacement = ->
  # Show the elements which are hidden on initial page load
  $('#ls-user-signin-with-flyout, #ls-user-signup').removeClass('ls-hide-visibility')
  $('#ls-user-signup').removeClass('ls-hide')

  moveFlyoutsToUpperContainer = matchMQ "(max-width: 960px)"
  if not Groupon.PageFlags.isLegacyResponsive
    moveFlyoutsToUpperContainer = false
  toggleUserMenuPlacement(moveFlyoutsToUpperContainer)

toggleUserMenuPlacement = (moveFlyoutsToUpperContainer) ->
  selector = if moveFlyoutsToUpperContainer then '.user-menu' else '#ls-header-lower-signin-container'
  $(selector).append($('#user-name, #ls-my-stuff, #ls-header-signin-flyout-container'))

updateReferrerUrls = (scope) ->
  addReferrer(scope)
  # update the urls when the location changed
  window.addEventListener 'changestate', ->
    addReferrer(scope)


User =
  init: ->
    return unless $('#ls-user-nav').length
    @showSigninFlyout = Groupon.LS.experiments?.showSigninFlyout
    @translations = Groupon.LS.translations?.userNav
    @country_US = (document.head.getAttribute('data-country') is 'US')
    @isLivingSocial = (document.head.getAttribute('data-brand') is 'livingsocial')
    @fetchWithTokenExchange()

  initFlyout: (user) ->
    SignInFlyout.init()
    @renderMyStuffMenu(user, 'ls-signin-flyout-mystuff-pane')
    SignInFlyout.bind()
    if Groupon.PageFlags.isLegacyResponsive
      addMQListener "(max-width: 960px)", (mq) ->
        toggleUserMenuPlacement(mq.matches)

  fetchWithTokenExchange: ->
    fetchUser.exchangeTokenIfNeed ( => @fetch())

  fetch: ->
    noUser_cb = =>
      updateReferrerUrls()
      if @showSigninFlyout
        updateSigninFlyoutPlacement()
        @initFlyout()
      setCartWidget()
      appendLanguageMenu(false)
      buildResponsiveMenu()
#      myPlacesWidget.fetchMyPlaces(false) # LS-2614: Check if my place changed
      return

    hasUser_cb = (res) =>
      @renderUserNav res
      if @showSigninFlyout
        updateSigninFlyoutPlacement()
        @initFlyout(res)

      @renderMyStuffLayout res
      Groupon.Modules.Header.bind()
      delete Groupon.Modules.Header
      setCartWidget()
      appendLanguageMenu(true)
      buildResponsiveMenu()
#      myPlacesWidget.fetchMyPlaces(true) # LS-2614: Fetch my places data
      return

    success = hasUser_cb

    {userId, hasUserData} = fetchUser.useStoredData(noUser_cb, hasUser_cb)
    return if hasUserData or not userId

    error = (err) ->
      noUser_cb()
      Groupon.Utils.trackEvent 'user-call-failed', err
      return

    fetchUser.fetch(userId, success, error)

  loadViewData: ->
    flagData = Groupon.LS.flags or {}
    hasLiteHeader = $('#ls-lite-header').length
    Object.assign flagData, {
      showWishlist: Groupon.LS.flags?.showWishlist
      t:                      @translations
      country_US:             @country_US
      showSigninFlyout:       @showSigninFlyout
      showLiteHeader:         hasLiteHeader
      enableBigSearch:        $('.big-searchbar').length?
      showCart:               Groupon.Cart?.showCart
    }

  renderMyStuffMenu: (user, containerId) ->
    data = Object.assign {}, @loadViewData(), { user }
    data.t?.myProfileLink ?= '/myprofile'
    if not user
      linksToUpdate = ['myGrouponsLink', 'myCardLinkedDealsLink', 'myWishlistLink', 'myAccountLink', 'myProfileLink']
      Object.keys(data.t).filter((i) -> linksToUpdate.indexOf(i) > -1).forEach (key) ->
        link = data.t[key]
        data.t[key] = "/login?metric=layout_login&ref=#{encodeURIComponent(link)}"
        return
      data.t['signUpLink'] = data.t['signUpLink'] + "?metric=layout_login"

    $('#' + containerId).html my_stuff_menu_template.render data

  renderUserNav: (user) ->
    data = Object.assign {}, @loadViewData(), { user }
    $('#ls-user-nav').html user_nav_template.render data

    if @showSigninFlyout
      $('#ls-header-signin-flyout-container').remove()

    @renderMyStuffMenu user, 'ls-my-stuff'
    updateReferrerUrls('#ls-user-nav')

    # Enable CPP get started link in the main user navigation menu if user
    # has a "has_cpp" cookie, which is set when user visits /u/get-started once.
    # Link should also be displayed if user is participating in AB experiment.
    # This is a "temporary" solution and might be lifted later after launch.
    if Cookie.get('has_cpp') in ['1', 'true']
      $('#user-my-page').removeClass 'hidden'

    buildResponsiveMenu()

    $('#sign-out, #ls-resp-sign-out').one 'click', fetchUser.removeUserData
    return

  renderMyStuffLayout: (user) ->
    return unless ($myStuffSelector = $('#ls-my-stuff-wrapper')).length
    current = Groupon.LS.CurrentMyStuffApp
    data = {
      current
      user
      t:                      @translations
      country_US:             @country_US
      isLivingSocial:         @isLivingSocial
      showMyFoodTab:          Groupon.LS.flags?.showMyFoodTab
      showMyLinkedDealsTab:   Groupon.LS.flags?.showMyLinkedDealsTab
      showMyReservationsTab:  Groupon.LS.flags?.showMyReservationsTab
      showMyProfile:          Groupon.LS.flags?.showMyProfile
    }
    $myStuffSelector.html my_stuff_layout_template.render data

Groupon.LS.User = {
  removeCachedUserData
}

module.exports = {
  User
}



// WEBPACK FOOTER //
// ./modules/gig_body/header/usernav/frontend/setup_user.coffee